import GoalsAPI from './GoalsAPI';
export default GoalsAPI;
